<template>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12 sm8 md4>
                <v-card class="elevation-12">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>Login</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-form @submit.prevent="onLogin()">
                            <v-text-field
                                v-validate="'required|email'"
                                prepend-icon="email"
                                name="Email"
                                label="Email"
                                :error-messages="errors.collect('email')"
                                data-vv-name="email"
                                required
                                v-model="email"
                            ></v-text-field>
                            <v-text-field
                                    v-validate="'required'"
                                    prepend-icon="lock"
                                    name="Password"
                                    label="Password"
                                    v-model="password"
                                    type="password"
                                    :error-messages="errors.collect('password')"
                                    data-vv-name="password"
                                    required
                            >
                            </v-text-field>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn :to="{ name: 'forgot'}" outline color="error">Forgot Password?</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn :disabled="isSubmitting" color="primary" @click="onSubmit()">Login</v-btn>
                    </v-card-actions>
                    <v-card-text>
                        <p>Need an account? Register <router-link :to="{name: 'register'}">here.</router-link></p>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

export default {
  name: 'Login',
  components: {
  },
  data () {
    return {
      isSubmitting: false,
      email: process.env.VUE_APP_LOGIN_EMAIL,
      password: process.env.VUE_APP_LOGIN_PASSWORD
    }
  },
  methods: {
    onSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.isSubmitting = true
          this.onLogin()
        } else {
          this.$snotify.error(this.$validator.errors.all())
        }
      })
    },
    onLogin () {
      let redirect = this.$auth.redirect()
      this.$auth.login({
        redirect: { name: redirect ? redirect.from.name : 'home' },
        data: { email: this.email, password: this.password }
      }).then(() => {
        // success
        this.$snotify.success('Logged in')
      }).catch(error => {
        // error
        if (error.response.status === 401) {
          this.$snotify.error(error.response.data.data.error)
        } else {
          this.$snotify.error(error.message)
        }
      }).finally(() => {
        this.isSubmitting = false
      })
    }
  }
}
</script>

<style scoped>

</style>
